export default __webpack_public_path__ + "static/media/francheville27.dae7f4c8.jpg";